import {
  Button,
  Flex,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@ritualco/jutsu'
import 'react-multi-email/style.css'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import { FormikMultiEmailInput } from 'components/Formik'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'
import { EmployeeCreateFormType, EmployeeCreateModalProps } from './types'

const initialValues: EmployeeCreateFormType = {
  emails: [],
}

export const EmployeeCreateModal = ({
  onSubmit,
  onClose,
  ...modalProps
}: EmployeeCreateModalProps) => {
  const { formatMessage } = useContent()
  const FormValueTypeSchema = Yup.object().shape({
    emails: Yup.array(Yup.string().email().required()).min(
      1,
      formatMessage({ id: 'pmportal.settings.team.errors.emails' })
    ),
  })

  return (
    <HeraModal size="2xl" onClose={onClose} {...modalProps}>
      <Formik
        initialValues={initialValues}
        validationSchema={FormValueTypeSchema}
        onSubmit={async (values, actions) => {
          await onSubmit(values.emails)
          actions.setSubmitting(false)
          onClose()
        }}
      >
        {props => (
          <>
            <ModalHeader>
              {formatMessage({
                id: 'pmportal.companies.inviteEmployees.header',
              })}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Form id="employeeCreate">
                <Flex direction="column">
                  <Text
                    fontSize="small"
                    color="grayscale.secondary"
                    mb={9}
                    mt={-1}
                  >
                    {formatMessage({
                      id: 'pmportal.companies.inviteEmployees.desc',
                    })}
                  </Text>
                  <FormikMultiEmailInput
                    label={formatMessage({
                      id: 'pmportal.companies.emailHeading',
                    })}
                    placeholder={formatMessage({
                      id: 'pmportal.companies.inviteEmployees.placeholder',
                    })}
                    name="emails"
                    isRequired
                    {...props}
                  />
                  <Text
                    fontWeight={'thin'}
                    fontSize="xs"
                    color="grayscale.secondary"
                  >
                    {formatMessage({
                      id: 'pmportal.companies.inviteEmployees.tip',
                    })}
                  </Text>
                </Flex>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="transparent" mr={2} onClick={onClose}>
                {formatMessage({ id: 'pmportal.global.actionCancel' })}
              </Button>
              <Button
                type="submit"
                form="employeeCreate"
                isLoading={props.isSubmitting}
              >
                {formatMessage({ id: 'pmportal.companies.sendInvites' })}
              </Button>
            </ModalFooter>
          </>
        )}
      </Formik>
    </HeraModal>
  )
}
